import { imageRepositoryResource } from "./imageRepository.resource.ts";
import { ImageRepositoryService } from "./imageRepository.service.ts";

export default angular.module("imageRepositoryModule", [])
    .service("imageRepositoryService", ImageRepositoryService)
    .service("imageRepositoryResource", imageRepositoryResource)
    .name;
